import { usePermissions } from "providers";
import { useEffect } from "react";

export const NotFound = () => {
  const { setErrorCode } = usePermissions();

  useEffect(() => setErrorCode(404));

  return null;
};
